import RoutePath from '../../../../../constants/routePath';

// TODO: consider moving all helpers to one file
export class ParentShareRouterHelper {

  static PARENT_SHARE_PATH = RoutePath.ROUTE_2BAP_PARENT_SHARE;
  
}
